<div class="auto-reservation-container">
  <div class="header-content">
    <div class="info">{{ 'AUTOS_MODULE.CARD.INFO' | transloco }}</div>
    <div class="image" [ngStyle]="getBackgroundImage('image')">
      <div class="logo" [ngStyle]="getBackgroundImage('logo')"></div>
    </div>
  </div>
  <h3>{{ model }}</h3>
  <div class="places">
    <div class="place pickup">
      <h4>{{ 'AUTOS_MODULE.DETAILS.PICKUP' | transloco }}:</h4>
      <p class="datetime">{{ pickUp }} • {{ pickUpTime }}</p>
      <p class="address">{{ pickUpPlace }}</p>
    </div>
    <div class="place dropoff">
      <h4>{{ 'AUTOS_MODULE.DETAILS.DROPOFF' | transloco }}:</h4>
      <p class="datetime">{{ dropOff }} • {{ dropOffTime }}</p>
      <p class="address">{{ dropOffPlace }}</p>
    </div>
  </div>
</div>